export default __webpack_public_path__ + "da543d67eb8e1ef16483025fd9d258fa.png";